import { SiteLink as Link } from '../../components/SiteLink';
import { CATEGORY_LABELS, serverPath, type CatalogServer } from '../../catalog';

/** The server's icon, or its initial when the catalog has none. */
export function ServerIcon({ server, size = 24 }: { server: CatalogServer; size?: number }) {
  return (
    <span className="ct-icon" style={{ width: size + 16, height: size + 16 }}>
      {server.iconUrl ? (
        <img src={server.iconUrl} alt="" width={size} height={size} loading="lazy" decoding="async" />
      ) : (
        <b>{server.name.charAt(0).toUpperCase()}</b>
      )}
    </span>
  );
}

export const hostingLabel = (s: CatalogServer) => (s.hosting === 'statio' ? 'Runs on Statio' : 'Vendor hosted');

export const authLabel = (s: CatalogServer) => ({ oauth: 'Sign in', key: 'API key', none: 'No credentials' })[s.auth];

/** One card in the catalog grid. The whole card is the link. */
export function ServerCard({ server }: { server: CatalogServer }) {
  return (
    <li className="ct-card">
      <Link to={serverPath(server.slug)}>
        <span className="ct-card-head">
          <ServerIcon server={server} />
          <span>
            <span className="ct-name">{server.name}</span>
            <span className="ct-cat">{CATEGORY_LABELS[server.category]}</span>
          </span>
        </span>
        <span className="ct-desc">{server.description}</span>
        <span className="ct-meta">
          <span>{hostingLabel(server)}</span>
          <span>{authLabel(server)}</span>
        </span>
      </Link>
    </li>
  );
}
